import { render, staticRenderFns } from "./LihatExcel.vue?vue&type=template&id=8fc31a00"
import script from "./LihatExcel.vue?vue&type=script&lang=js"
export * from "./LihatExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports